<script lang="ts">
	import CkEditorContent from "@components/common/CkEditorContent.svelte";
	import Heading from "@components/common/Heading.svelte";
	import type { ContentType } from "@core/schema/ContentType.js";
	import type { ContentBlockComponentProps } from "./ContentBlockComponentProps.js";

	const { data, lightboxId }: ContentBlockComponentProps<ContentType.BrownCard> = $props();
</script>

<div class="bg-fcrbrown text-fcrbeige p-6 lg:p-12 xl:p-19 rounded-2xl container-8">
	<Heading
		level={2}
		text={data.heading}
		class="leading-tighter text-1.5xl lg:text-3.5xl mb-4 lg:mb-8 xl:mb-12 font-antipol"
	/>
	<CkEditorContent html={data.contentHtml} {lightboxId} />
</div>
